import * as React from 'react';
export var IconMagnifyingglass = React.forwardRef(function IconMagnifyingglass({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M11.883 10.823a5.5 5.5 0 1 0-1.06 1.06l1.897 1.897a.75.75 0 1 0 1.06-1.06l-1.897-1.897ZM11.5 7.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M15.596 14.535a6.5 6.5 0 1 0-1.06 1.06l4.184 4.185a.75.75 0 1 0 1.06-1.06l-4.184-4.185ZM15.5 10.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M15.596 14.535a6.5 6.5 0 1 0-1.06 1.06l4.184 4.185a.75.75 0 1 0 1.06-1.06l-4.184-4.185ZM15.5 10.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
